import { DateFormat } from '@agroone/dates'
import { IsDateValidate } from '@agroone/helpers'
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateIf } from 'class-validator'

export class PatchOfferDto {
  @IsString()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  groupCode?: string | null

  @IsString()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  confirmedHarvestDate?: string | null

  @IsString()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  lastCheckOutSiteDate?: string | null

  @IsNumber()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  status?: number | null

  @IsNumber()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  durationLots?: number | null

  @IsNumber()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  harvestTeamId?: number | null

  @IsNumber()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  cadence?: number | null

  @IsNumber()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  speed?: number | null

  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  startHarvestDate?: Date | null

  @IsNumber()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  replaceOfferId?: number | null

  @IsNumber()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  droppedAfterOfferId?: number | null

  @IsNumber()
  @IsOptional()
  @ValidateIf((_, value) => value !== null)
  stockId?: number | null

  @IsString()
  @IsDateValidate(DateFormat.YYYY_MM_DD)
  @IsOptional()
  yesterdayDate?: string

  @IsBoolean()
  @IsOptional()
  impossibleMix?: boolean

  @IsBoolean()
  @IsOptional()
  weekStart?: boolean
}
